import { Box, InputBase, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getNotes } from "../../api/user";
import notNote from "../../assets/image/notNote.png";
import BookmarkIcon from "../../assets/SVG/bookmarkIcon";
import NoteAddIcon from "../../assets/SVG/noteAddIcon";
import NoteCard from "./noteCard";

export default function NotePage() {
  const [noteData, setNoteData] = useState([]);
  const [showNewNote, setShowNewNote] = useState();
  useEffect(() => {
    getNotes()
      .then((x) => setNoteData(x))
      .catch(() => {});
  }, []);
  return (
    <>
      <Box
        display={"flex"}
        flexWrap="wrap"
        mt={noteData.length >= 1 || showNewNote ? "50px" : ""}
        gap="10px"
      >
        {noteData.length >= 1 &&
          noteData.map((x) => <NoteCard setNoteData={setNoteData} data={x} />)}
        {showNewNote && (
          <NoteCard setShowNewNote={setShowNewNote} setNoteData={setNoteData} />
        )}
        {noteData.length >= 1 && (
          <Box
            bgcolor="#F5F9FF"
            width="240px"
            p="20px"
            height="242px"
            borderRadius={"13px"}
            onClick={() => setShowNewNote(true)}
          >
            <Box
              display={"flex"}
              sx={{ cursor: "pointer" }}
              height="85%"
              justifyContent="center"
              alignItems="center"
              mt="20px"
            >
              <NoteAddIcon />
              <Typography color="#4C8395">ایجاد یادداشت</Typography>
            </Box>
          </Box>
        )}
      </Box>
      {/* )} */}
      {noteData.length === 0 && !showNewNote && (
        <>
          <Box
            display={"flex"}
            sx={{ cursor: "pointer" }}
            width="fit-content"
            alignItems="center"
            mt="20px"
            onClick={() => setShowNewNote(true)}
          >
            <NoteAddIcon />
            <Typography color="#4C8395">ایجاد یادداشت</Typography>
          </Box>
          <Box
            height="70%"
            display="flex"
            alignItems={"center"}
            justifyContent="center"
          >
            <img src={notNote} />
          </Box>
        </>
      )}
    </>
  );
}
